export default __webpack_public_path__ + "static/media/09-RetroDonut.e7d494c7.png";